import { infoFetchGetTituloI, makeTitulo } from "dtos/titulo";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFetchGetTipoEspacioI, makeTipoEspacio } from "dtos/tipoEspacio";

export const getTipoEspacio = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetTipoEspacioI>
  >({
    method: "GET",
    uri: ENDPOINTS.TIPO_ESPACIO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeTipoEspacio(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postTipoEspacio = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetTipoEspacioI>({
    method: "POST",
    uri: ENDPOINTS.TIPO_ESPACIO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeTipoEspacio(response);
};

export const putTipoEspacio = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetTipoEspacioI>({
    method: "PUT",
    uri: ENDPOINTS.TIPO_ESPACIO,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeTipoEspacio(response);
};

export const deleteTipoEspacio = async (id: any) => {
  const response = await sendRequest<infoFetchGetTipoEspacioI>({
    method: "DELETE",
    uri: ENDPOINTS.TIPO_ESPACIO + "/" + id,
  });
  return makeTipoEspacio(response);
};
